'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_patterns_PolicyModal_PolicyPendingCheck_utils = require('./utils.cjs.js');
const components_patterns_PolicyModal_PolicyModal = require('../PolicyModal.cjs.js');
const components_patterns_PolicyModal_PolicyPendingCheck_useQueryPolicyPending = require('./useQueryPolicyPending.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const SNOOZE_COOKIE_PREFIX = "policySnooze";
const SNOOZE_COOKIE_EXP = 60 * 60;
const EVENT_POLICY_INTERACTION_NAME = "policy_pending_check";
const formatSlugForCookie = (slug) => `${SNOOZE_COOKIE_PREFIX}_${slug}`;
const silenceLogger = (slug, reasons) => {
  console.info(`Silencing pending policy \`${slug}\` because ${reasons}.`);
};
const PolicyPendingCheck = (props) => {
  const { policy, acceptPolicy } = components_patterns_PolicyModal_PolicyPendingCheck_useQueryPolicyPending.useQueryPolicyPending(props.zapierUrl || "");
  React.useEffect(() => {
    if (policy) {
      components_patterns_PolicyModal_PolicyPendingCheck_utils.emitUserInteractionEvent({
        interaction_name: EVENT_POLICY_INTERACTION_NAME,
        event_action: "in_view",
        option_selected: `${policy.slug} ${policy.content}`
      });
    }
  }, [policy]);
  const onAccept = React.useCallback(async () => {
    if (!policy) {
      return null;
    }
    components_patterns_PolicyModal_PolicyPendingCheck_utils.emitUserInteractionEvent({
      interaction_name: EVENT_POLICY_INTERACTION_NAME,
      event_action: "click",
      option_selected: `${policy.slug} ${policy.content}`
    });
    try {
      await acceptPolicy();
    } catch (_a) {
      components_patterns_PolicyModal_PolicyPendingCheck_utils.setCookie(formatSlugForCookie(policy.slug), "from_accept_err", SNOOZE_COOKIE_EXP);
    }
  }, [policy]);
  if (!policy) {
    return null;
  }
  if (props.currentPathname === policy.slug) {
    silenceLogger(policy.slug, "pathname");
    return null;
  }
  const hasSnoozeCookie = Boolean(components_patterns_PolicyModal_PolicyPendingCheck_utils.getCookie(formatSlugForCookie(policy.slug)));
  if (hasSnoozeCookie) {
    silenceLogger(policy.slug, "snooze is on");
    return null;
  }
  return React__default.default.createElement(components_patterns_PolicyModal_PolicyModal.PolicyModal, { onAccept, renderMarkdown: props.renderMarkdown, title: policy.title, tldr: policy.tldr, url: `https://zapier.com/${policy.slug}` });
};

exports.PolicyPendingCheck = PolicyPendingCheck;
//# sourceMappingURL=PolicyPendingCheck.cjs.js.map
